import PropTypes from 'prop-types';
import React from 'react';
import { Link } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import {
  Table,
  TableRow,
  TableCell,
  TableBody,
  IconButton,
  CircularProgress,
} from '@material-ui/core';
import CheckIcon from '@mui/icons-material/Check';
import BlockIcon from '@mui/icons-material/Block';
import { withStyles } from '@material-ui/core/styles';

import CapBalance from 'retired/CapBalance';
import { red } from 'utils/color-styles';
import { PureRender } from 'utils/component-helpers';
import { Privileges } from 'utils/privileges';
import { formatFullName } from 'utils/formatFullName';

import { verifyAction } from './actions';

const styles = () => ({
  button: {
    padding: '7px 8px',
    minWidth: 64,
    fontSize: '0.8125rem',
    minHeight: 32,
  },
  accepted: {
    color: '#000 !important',
  },
  rejected: {
    color: `${red} !important`,
  },
  pendingAccept: {
    color: 'rgba(0, 0, 0, 0.3) !important',
    '&:hover': {
      color: '#000 !important',
    },
  },
  pendingReject: {
    color: 'rgba(0, 0, 0, 0.3) !important',
    '&:hover': {
      color: `${red} !important`,
    },
  },
});

const VolunteersTable = ({ header, volunteers, isCompany, verifying, classes, user, loading }) => {
  const dispatch = useDispatch();
  return (
    <Table size="small" style={{ marginTop: -10 }}>
      {header}
      <TableBody
        style={{
          ...(loading && {
            opacity: 0.3,
            cursor: 'wait',
            pointerEvents: 'none',
          }),
        }}
      >
        {volunteers
          .map((volunteer) => (
            <TableRow key={volunteer.id}>
              <TableCell>
                <Link to={`/volunteers/${volunteer.id}`}>
                  {formatFullName(volunteer.fullName) || '-'}
                </Link>
              </TableCell>
              {isCompany ? <TableCell>{volunteer.organizationDepartment || '-'}</TableCell> : null}
              <TableCell>{volunteer.city || '-'}</TableCell>
              <TableCell>{volunteer.state || volunteer.stateCode || '-'}</TableCell>
              <TableCell>{volunteer.country || volunteer.countryCode || '-'}</TableCell>
              <TableCell>{Number((volunteer._volunteerMinutes / 60).toFixed(2)) || '-'}</TableCell>
              <TableCell>{volunteer.phone || '-'}</TableCell>
              <TableCell style={{ wordBreak: 'break-all' }}>{volunteer.email || '-'}</TableCell>
              {isCompany ? (
                <>
                  {user.hasPrivilege(Privileges.DONATION_VIEW) && (
                    <TableCell>
                      <CapBalance
                        capBalanceByBudget={volunteer._capBalanceByBudget}
                        unlimitedMessaging="unlimited in"
                      />
                    </TableCell>
                  )}
                  <TableCell>
                    {verifying.has(volunteer.id) ? (
                      <CircularProgress size={24} style={{ margin: '10px 12px' }} />
                    ) : (
                      <div
                        style={{
                          width: 104,
                          paddingLeft: 4,
                          paddingRight: 4,
                        }}
                      >
                        <IconButton
                          title="Approve"
                          onClick={() =>
                            volunteer.status !== 'accepted' &&
                            dispatch(verifyAction('approve', volunteer.id))
                          }
                          classes={{
                            root: volunteer.status !== 'accepted' && classes.pendingAccept,
                            disabled: classes.accepted,
                          }}
                          disabled={volunteer.status === 'accepted'}
                        >
                          <CheckIcon />
                        </IconButton>
                        <IconButton
                          title="Deny"
                          onClick={() =>
                            volunteer.status !== 'rejected' &&
                            dispatch(verifyAction('reject', volunteer.id))
                          }
                          classes={{
                            root: volunteer.status !== 'rejected' && classes.pendingReject,
                            disabled: classes.rejected,
                          }}
                          disabled={volunteer.status === 'rejected'}
                        >
                          <BlockIcon />
                        </IconButton>
                      </div>
                    )}
                  </TableCell>
                </>
              ) : null}
            </TableRow>
          ))
          .toArray()}
      </TableBody>
    </Table>
  );
};
VolunteersTable.propTypes = {
  volunteers: PropTypes.object,
  header: PropTypes.object,
  isCompany: PropTypes.bool,
  verifying: PropTypes.object,
  classes: PropTypes.object,
  user: PropTypes.object,
  loading: PropTypes.bool,
};
export default PureRender(withStyles(styles)(VolunteersTable));
